import React from 'react';
import * as Styles from 'pages/function1/styles';
import coinplug_logo from 'assets/coinplug-logo-horizo.png';
import authRequest from '../../service/authRequest';
import config from 'config';

const serviceId = config.mykeepin.serviceId;
const type = config.mykeepin.authType.function1;
const redirectUri = config.mykeepin.redirectUri.function1;

// Page function1 (페이지명은 function1 에서 추후에 바뀔 수 있음)
class function1 extends React.Component {

  render() {
    return (
      <Styles.PageLayout>
        <Styles.GridLayout>
          {/* 최상단 coinplug logo */}
          <Styles.LogoContainer>
            <Styles.Logo src={coinplug_logo} alt="coinplug-logo" />
          </Styles.LogoContainer>
          {/* 상단 페이지 제목 */}
          <Styles.PageTitle>
            AUTH SAMPLE
          </Styles.PageTitle>
          {/* 샘플 텍스트 */}
          <Styles.Paragraph>
            Metadium DID 기반 인증 서비스를 테스트합니다. 본 테스트는 VP를 요청하지 않는 type을 사용하기 때문에 인증한 유저에게 개인정보를 받아오지 않습니다. 인증 Code 값을 검증하면, 인증한 유저의 DID 값과 Signature 값을 받습니다.
          </Styles.Paragraph>
          {/* 로그인 버튼 */}
          <Styles.LoginButtonContainer>
            <Styles.LoginButtonWrapper>
              <Styles.LoginButton onClick={this.onClickLoginButton}> Login </Styles.LoginButton>
            </Styles.LoginButtonWrapper>
          </Styles.LoginButtonContainer>
        </Styles.GridLayout>
      </Styles.PageLayout>
    )
  }

  onClickLoginButton = async () => {
    // 인증 요청 URI 로 리다이렉트
    const authRequestUri = authRequest({ serviceId, redirectUri, type });
    window.location.assign(authRequestUri);
  }
}

export default function1;